export default class VerticalLineElement {
  constructor (name, lengthRel, initXRel, initYRel, color, weight, drawUp = false) {
    this.name = name
    this.lengthRel = lengthRel
    this.initXRel = initXRel
    this.initYRel = initYRel

    this.color = color
    this.weight = weight
    this.drawUp = drawUp

    this.x = null
    this.y = null
    this.length = null
  }

  setOnScene (sceneWidth, sceneHeight) {
    this.length = sceneHeight * this.lengthRel
    this.x = sceneWidth * this.initXRel
    this.y = sceneHeight * this.initYRel
  }

  getConfig () {
    let secondPointY = this.drawUp ? (-this.length) : this.length
    return {
      x: this.x,
      y: this.y,
      points: [0, 0, 0, secondPointY],
      stroke: this.color,
      strokeWidth: this.weight
    }
  }
}
